import { useCallback, useState } from 'react'
import { Building2, Landmark, Layers } from 'lucide-react'
import type { SegmentedControlOption } from '@/components/ui/SegmentedControl'
import type { ExpenseScopeType } from '@/features/expenses/types/expense.types'

/** What an organization expense shows where a company name would be. */
export const ORGANIZATION_LABEL = 'Organization'

/**
 * An expense is a company expense (it belongs to one company) or an
 * organization expense (the organization itself carries it: head-office rent,
 * a subscription everyone uses). The expense pages show all of them, or one kind.
 */
export const EXPENSE_SCOPE_OPTIONS: SegmentedControlOption<ExpenseScopeType>[] = [
  { value: 'all', label: 'All expenses', icon: Layers },
  { value: 'organization', label: 'Organization', icon: Landmark },
  { value: 'company', label: 'Companies', icon: Building2 },
]

export interface ExpenseScopeState {
  scope: ExpenseScopeType
  setScope: (scope: ExpenseScopeType) => void
}

export function useExpenseScope(onChange?: () => void): ExpenseScopeState {
  const [scope, setScopeState] = useState<ExpenseScopeType>('all')
  const setScope = useCallback(
    (next: ExpenseScopeType) => {
      setScopeState(next)
      onChange?.()
    },
    [onChange],
  )
  return { scope, setScope }
}

/** The company picker only narrows company expenses. */
export function scopedCompanyIds(
  scope: ExpenseScopeType,
  companyIds: string[] | undefined,
): string[] | undefined {
  return scope === 'company' ? companyIds : undefined
}
